import { css } from 'styled-components';

const button = css`
  color: var(--text-primary);
  background-color: transparent;
  border: 1px solid var(--text-primary);
  border-radius: var(--border-radius);
  font-size: var(--fz-sm);
  font-family: var(--font-mono);
  line-height: 1;
  text-decoration: none;
  padding: var(--space-md) var(--space-xl);
  transition: var(--transition-base);
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  &:hover,
  &:focus-visible {
    outline: none;
    background-color: var(--text-primary);
    color: var(--bg-primary);
    box-shadow: 0 4px 16px var(--shadow-md);
    transform: translateY(-2px);
  }
  &:after {
    display: none !important;
  }
`;

const mixins = {
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  link: css`
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    color: inherit;
    position: relative;
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      color: var(--text-primary);
      outline: 0;
      opacity: 0.7;
    }
  `,

  inlineLink: css`
    display: inline-block;
    position: relative;
    color: var(--text-primary);
    transition: var(--transition-base);

    &:hover,
    &:focus-visible {
      color: var(--text-primary);
      outline: 0;
      opacity: 0.7;
      &:after {
        width: 100%;
      }
      & > * {
        color: var(--text-primary) !important;
        transition: var(--transition-base);
      }
    }
    &:after {
      content: '';
      display: block;
      width: 0;
      height: 1px;
      position: relative;
      bottom: 0.3em;
      background-color: var(--text-primary);
      opacity: 0.4;
      @media (prefers-reduced-motion: no-preference) {
        transition: var(--transition-base);
      }
    }
  `,

  button,

  smallButton: css`
    color: var(--text-primary);
    background-color: transparent;
    border: 1px solid var(--text-primary);
    border-radius: var(--border-radius);
    padding: var(--space-sm) var(--space-md);
    font-size: var(--fz-xs);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    transition: var(--transition-base);
    font-weight: 500;
    letter-spacing: 0.05em;
    text-transform: uppercase;

    &:hover,
    &:focus-visible {
      outline: none;
      background-color: var(--text-primary);
      color: var(--bg-primary);
      box-shadow: 0 4px 12px var(--shadow-md);
      transform: translateY(-1px);
    }
    &:after {
      display: none !important;
    }
  `,

  bigButton: css`
    color: var(--text-primary);
    background-color: transparent;
    border: 1px solid var(--text-primary);
    border-radius: var(--border-radius);
    padding: var(--space-lg) var(--space-2xl);
    font-size: var(--fz-md);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    transition: var(--transition-base);
    font-weight: 500;
    letter-spacing: 0.05em;
    text-transform: uppercase;

    &:hover,
    &:focus-visible {
      outline: none;
      background-color: var(--text-primary);
      color: var(--bg-primary);
      box-shadow: 0 6px 20px var(--shadow-md);
      transform: translateY(-2px);
    }
    &:after {
      display: none !important;
    }
  `,

  boxShadow: css`
    box-shadow: 0 4px 16px var(--shadow-sm);
    transition: var(--transition-base);

    &:hover,
    &:focus-visible {
      box-shadow: 0 8px 24px var(--shadow-md);
    }
  `,

  fancyList: css`
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: var(--fz-lg);
    li {
      position: relative;
      padding-left: 30px;
      margin-bottom: 10px;
      &:before {
        content: '—';
        position: absolute;
        left: 0;
        color: var(--text-primary);
        font-size: 1em;
        font-weight: 300;
        opacity: 0.5;
      }
    }
  `,

  resetList: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
};

export default mixins;
